import { render, staticRenderFns } from "./VineyardFertilizerMetricTable.vue?vue&type=template&id=9187d4fa&scoped=true&"
import script from "./VineyardFertilizerMetricTable.vue?vue&type=script&lang=js&"
export * from "./VineyardFertilizerMetricTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9187d4fa",
  null
  
)

export default component.exports